export const preparePairingList = (pairingList) => {
  if (!pairingList?.length) return []

  return pairingList.sort((a, b) => {
    if (a.round !== b.round) return a.round - b.round;
    if (a.podNum && !b.podNum) return -1;
    if (!a.podNum && b.podNum) return 1;
    if (a.podNum < b.podNum) return -1;
    if (a.podNum > b.podNum) return 1;

    if (
      a.bracketPairingNum !== undefined &&
      b.bracketPairingNum === undefined
    )
      return -1;
    if (
      a.bracketPairingNum === undefined &&
      b.bracketPairingNum !== undefined
    )
      return 1;
    if (a.bracketPairingNum < b.bracketPairingNum) return -1;
    if (a.bracketPairingNum > b.bracketPairingNum) return 1;
    return 0;
  }).filter(pairing => pairing.player1?.id || pairing.player2?.id)
}

export const getTopCutPairingList = (pairingList, podRound = -1) => {
  return pairingList.filter(pairing => pairing.round >= podRound && pairing?.podNum === 1)
}